module.exports = __webpack_public_path__ + "static/media/orgRemoteEvaluationScoreFileImport.105ebec7.xlsx";